import React, { Dispatch, SetStateAction } from 'react';
import RPLDatatable from '@hid-galaxy-ui/galaxy-react/components/DataTable';
import { Loader, LoaderSizes, Pagination } from '@hid-galaxy-ui/galaxy-react';
import { PageSize } from '../../constants/common';
import { getTotalRowCount, getTranslation } from '../../utils/functions';
import { IDataTableProps } from './IDataTable';

const pageSizes = ['10', '20', '30', '40', '50'];

const DataTable = (props: IDataTableProps) => {
  const {
    data,
    isPageLoading = false,
    noDataErrorType,
    shouldRenderPagination,
    paginationData,
    handlePageNumberClick,
    currentPage,
    columnsConfig,
    dataKey,
    onPageSizesClick,
    dependencies,
  } = props;

  const getPageSizes = () => {
    return pageSizes.map((pageSize) => {
      return {
        label: pageSize,
        value: pageSize,
      };
    });
  };
  const renderDataTable = () => {
    return (
      <>
        {isPageLoading && <Loader isOverlay variant={LoaderSizes.large} />}
        <div className="hid-table__responsive">
          <RPLDatatable
            data={data}
            columns={columnsConfig}
            dataKey={dataKey || 'id'}
            dependencies={dependencies}
            emptyHandlerInfo={{
              isEmpty: !data.length,
              renderError: () => <div>{getTranslation('NO_RESULTS')}</div>,
            }}
          />
        </div>
      </>
    );
  };
  const renderPagination = () => {
    return (
      <Pagination
        currentPageNumber={currentPage}
        onPageNumberClick={handlePageNumberClick}
        onPageSizesClick={onPageSizesClick}
        totalRecords={getTotalRowCount(paginationData)}
        pageSize={PageSize}
        pageSizes={getPageSizes()}
      />
    );
  };

  return (
    <>
      {renderDataTable()}
      {shouldRenderPagination && renderPagination()}
    </>
  );
};

export default DataTable;
